/* global window: true */
import React from 'react';
import ReactDOM from 'react-dom';

import './Slide.scss';
import colorHelper from '../../lib/colorLuminance';

const SlidePlaceholder = (props) => {

    const { companyProfile } = props;
    
    let colorprofile = {};
    if (companyProfile) {
        const lighterColor = colorHelper.colorLuminance(companyProfile.colors.mainBg, 0);
        colorprofile.background = lighterColor;
    }
    return (
        <div className="slide_placeholder" style={colorprofile}>
        </div>
    );
};

export default SlidePlaceholder;



/** WEBPACK FOOTER **
 ** ./client/components/Slide/SlidePlaceholder.jsx
 **/